import { Disclosure } from 'aria-components';

/**
 * Accordion Item component.
 */
class AtslsAccordionItem extends HTMLElement {
  /**
   * Called by the browser when the element is added to the page.
   */
  connectedCallback() {
    this.button = this.querySelector('.accordion-item__button');
    this.disclosure = new Disclosure({
      controller: this.button,
      target: this.querySelector('.accordion-item__wrapper'),
    });
  }
}

// Define the custom elements.
customElements.define('atsls-accordion-item', AtslsAccordionItem);
